"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/NRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_175)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_175`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-3.12 0.000244141H32.88V23.9998H-3.12V0.000244141Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-3.12 10.8745H32.88V13.1245H-3.12V10.8745Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.17077 17.9996L7.82611 18.6321L8.54218 19.9344L7.082 19.655L6.897 21.1301L5.88 20.0452L4.86293 21.1301L4.67801 19.655L3.21783 19.9344L3.93382 18.6321L2.58923 17.9996L3.93389 17.3671L3.21783 16.0649L4.67794 16.3442L4.863 14.8691L5.88 15.954L6.89707 14.8691L7.082 16.3442L8.54218 16.0649L7.82618 17.3672L9.17077 17.9996Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_175`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as NRFlag };
